import { render, staticRenderFns } from "./SidePanel.vue?vue&type=template&id=bd6a1250&scoped=true&"
import script from "./SidePanel.vue?vue&type=script&lang=js&"
export * from "./SidePanel.vue?vue&type=script&lang=js&"
import style0 from "./SidePanel.vue?vue&type=style&index=0&id=bd6a1250&scoped=true&lang=css&"
import style1 from "./SidePanel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6a1250",
  null
  
)

/* custom blocks */
import block0 from "./SidePanel.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd6a1250')) {
      api.createRecord('bd6a1250', component.options)
    } else {
      api.reload('bd6a1250', component.options)
    }
    module.hot.accept("./SidePanel.vue?vue&type=template&id=bd6a1250&scoped=true&", function () {
      api.rerender('bd6a1250', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/PlaceFloorPlans/SidePanel.vue"
export default component.exports